import { saveAs } from 'file-saver';
import { ExcelWorkbook } from './models/ExcelWorkbook';
import { toExcelCell } from './toExcelCell';

const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function saveExcelSpreadsheet(props: { workbook: ExcelWorkbook; fileName: string }) {
  const { workbook, fileName } = props;

  const { default: writeXlsxFile } = await import(/* webpackPreload: true */ 'write-excel-file/browser');

  const sheets = workbook.SheetNames.map((sheetName) => {
    const sheetData = workbook.Sheets[sheetName];

    return {
      name: sheetName,
      data: [
        sheetData.orderedHeaders,
        ...sheetData.data.map((row) => sheetData.orderedHeaders.map((header) => toExcelCell(row[header]))),
      ],
    };
  });

  const blob = await writeXlsxFile(sheets).toBlob();

  saveAs(
    new Blob([blob], {
      type: XLSX_MIME_TYPE,
    }),
    fileName,
  );
}
